<app-modal
  class="view-document-modal"
  [allowClose]="false"
  [(visible)]="visible"
>
  <div class="address-exist-text">
    <div>
      This address information already exists with the following Customer Address ID:
      <strong>{{ addressId }}</strong>
    </div>

    <div>
      Are you sure you want to create a new AID?
    </div>
  </div>

  <footer>
    <app-button
      class="header-button"
      text="Yes"
      (onClick)="onConfirm()"
    ></app-button>

    <app-button
      classes="secondary"
      text="No"
      (onClick)="onCancel()"
    ></app-button>
  </footer>
</app-modal>
